// import { setQuickFilter } from '../../../../redux/slices/sahelSlice';
import { useDispatch, useSelector } from 'react-redux';
import SahelModal from '../common/SahelModal';
import OnboardingPresentation from './OnboardingPresentation';
import { setQuickFilter } from '../../../../redux/slices/mapSlice';

const OnboardingContainer = () => {
  const isMobile = useSelector((state: any) => state.app.isMobile);
  const dispatch = useDispatch();
  const closeNawyNowModal = () => {
    dispatch(setQuickFilter(null));
  };

  return (
    <>
      {isMobile ? (
        <OnboardingPresentation />
      ) : (
        <SahelModal handleClose={closeNawyNowModal} isOnboarding={true}>
          <OnboardingPresentation />
        </SahelModal>
      )}
    </>
  );
};

export default OnboardingContainer;
